import { useCallback } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { NPSDReportsGrid } from '@/components/npsd/NPSDReportsGrid';

interface NPSDBusinessHistoryProps {
  reports: any[];
  businessId?: number | string | null;
  onViewReport?: (reportId: any) => void;
}

export function NPSDBusinessHistory({
  reports = [],
  businessId,
  onViewReport,
}: NPSDBusinessHistoryProps) {
  const { theme } = useTheme();

  const handleViewReport = useCallback((reportId: any) => {
    onViewReport?.(reportId);
  }, [onViewReport]);

  return (
    <div className={`npsd-business-history ${theme}`}>
      <NPSDReportsGrid
        reports={reports}
        title="Reports Involving Business"
        entityType="business"
        sortable={true}
        onViewReport={handleViewReport}
      />
    </div>
  );
}

(window as any).NPSDBusinessHistoryReact = NPSDBusinessHistory;
